// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Weaver, WeaverGraph, WeaverObject;

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  WeaverGraph = (function() {
    class WeaverGraph extends WeaverObject {
      constructor(id) {
        super(id);
      }

      static async list(target) {
        var g, i, len, list, results;
        list = (await POST("v2.projects", {
          method: "GET",
          path: "/graphs"
        }, target));
        results = [];
        for (i = 0, len = list.length; i < len; i++) {
          g = list[i];
          results.push(new Weaver.Graph(g.uid));
        }
        return results;
      }

    };

    WeaverGraph.default = new WeaverGraph(void 0);

    return WeaverGraph;

  }).call(this);

  module.exports = WeaverGraph;

}).call(this);
